<template>
  <AdminLive :admin="this.recruiter">
    <div style="height: 100vh;" id="meet"></div>
  </AdminLive>
</template>

<script>
import AdminLive from "layouts/AdminLive.vue";
export default {
  components: { AdminLive },
  props: ["recruiter", "uid", "recruiter_id", "room_recruiter"],
  mounted() {
    const domain = "teste2.teste.jovool.com/teste";
    const options = {
      roomName: this.uid,
      width: "100%",
      height: "100%",
      parentNode: document.querySelector("#meet")
    };
    const api = new JitsiMeetExternalAPI(domain, options);
  }
};
</script>
